export const timesheetIndexRoute = '/timesheet';

interface GetTimesheetRouteParams {
  staff?: boolean;
  includePrivate?: boolean;
}

const getQueryParams = (params: GetTimesheetRouteParams) => {
  const { staff, includePrivate } = params;
  const paramsString = new URLSearchParams();
  if (staff) {
    paramsString.append('staff', 'true');
  }
  if (includePrivate) {
    paramsString.append('includePrivate', 'true');
  }
  return paramsString.toString() ? `?${paramsString.toString()}` : '';
};

export const getTimesheetRoute = (id: string, params: GetTimesheetRouteParams = {}) => {
  return `${timesheetIndexRoute}/${id}${getQueryParams(params)}`;
};

interface GetTimesheetEntryRouteParams extends Omit<GetTimesheetRouteParams, 'includePrivate'> {
  tab?: 'details' | 'approval-history';
}

export const getTimesheetEntryRoute = (id: string, entryId: string, params: GetTimesheetEntryRouteParams = {}) => {
  const { tab = 'details' } = params;
  return `${getTimesheetRoute(id)}/entry/${entryId}/${tab}${getQueryParams(params)}`;
};
